module.exports = __webpack_public_path__ + "static/wilko_simon-5446e569ca6275fbea8e8fa8a81fa0a1.jpeg";